module.exports = __webpack_public_path__ + "static/Detail-Row-e5b03ef29ac24a0aa85e299b842bb338.png";